import React from 'react';
import { useFilteringEnabled } from 'hooks/use-filtering-enabled.hook';
import { LocationSelector } from 'pages/landing/components/location-selector';
import { useResourceLoadingHandler } from 'pages/resources/hooks';
import { useIsSmallViewportWidth } from 'hooks/use-is-small-viewport-width.hook';
import { useFloorplanViewState } from 'floorplan/pages/native-floorplan/hooks/use-floorplan-view-state.hook';

export const LocationPicker = (): JSX.Element => {
  const isFilteringEnabled = useFilteringEnabled();
  const isLoadingState = useResourceLoadingHandler(isFilteringEnabled);
  const isMobileDevice = useIsSmallViewportWidth();
  // The page knows it is the redesigned one; the field itself does not have to.
  const { isFloorplanAvailable } = useFloorplanViewState();

  if (!isFilteringEnabled || (!isMobileDevice && isLoadingState)) return null;

  return <LocationSelector isResourcesPage isFloorplanUi={isFloorplanAvailable} />;
};
